/* --- FILE: src/components/Footer/Footer.js --- */
import React from 'react';
import { Container, Row, Col, Form, Button, InputGroup, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import './Footer.css';

export const Footer = () => {
    return (
        <footer className="footer-area">
            <Container>
                <Row>
                    {/* Column 1: Brand & About */}
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-logo mb-3">
                            {/* Assuming you want the white logo on dark footer */}
                            <Image src="images/logowhite.png" alt="KCCC Logo" fluid style={{ maxWidth: '200px' }} />
                        </div>
                        <p className="footer-desc">
                            Kingdom Connection Christian Center (KCCC) is dedicated to raising citizens for God's Kingdom, empowering lives through the word of God, and spreading the gospel of Jesus Christ.
                        </p>
                        <div className="social-links mt-4">
                            <a href="#" className="social-icon"><FontAwesomeIcon icon={faFacebookF} /></a>
                            <a href="#" className="social-icon"><FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="#" className="social-icon"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="#" className="social-icon"><FontAwesomeIcon icon={faYoutube} /></a>
                        </div>
                    </Col>

                    {/* Column 2: Quick Links */}
                    <Col lg={2} md={6} xs={6} className="mb-4">
                        <h5 className="footer-title">Quick Links</h5>
                        <ul className="footer-list">
                            <li><Link to="/" reloadDocument>Home</Link></li>
                            <li><Link to="/about" reloadDocument>About Us</Link></li>
                            <li><Link to="/sermons" reloadDocument>Sermons</Link></li>
                            <li><Link to="/events" reloadDocument>Events</Link></li>
                            <li><Link to="/give" reloadDocument>Give</Link></li>
                        </ul>
                    </Col>

                    {/* Column 3: Contact Info */}
                    <Col lg={3} md={6} xs={6} className="mb-4">
                        <h5 className="footer-title">Contact Us</h5>
                        <ul className="footer-contact">
                            <li>
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="icon-red" />
                                <span>1391 Oswego Street, Aurora, Colorado 80010</span>
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faPhone} className="icon-red" />
                                <span>+1-720-859-1737</span>
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faEnvelope} className="icon-red" />
                                <span>info@kccconline.org</span>
                            </li>
                        </ul>
                    </Col>

                    {/* Column 4: Newsletter */}
                    <Col lg={3} md={6} className="mb-4">
                        <h5 className="footer-title">Newsletter</h5>
                        <p className="text-white-50 small">Subscribe to get the latest updates and sermon notifications.</p>
                        <Form>
                            <InputGroup className="mb-3 footer-input-group">
                                <Form.Control
                                    placeholder="Email Address"
                                    aria-label="Email Address"
                                    className="footer-input"
                                />
                                <Button id="footer-btn">
                                    SUBSCRIBE
                                </Button>
                            </InputGroup>
                        </Form>
                    </Col>
                </Row>

                <hr className="footer-divider" />

                <Row className="align-items-center">
                    <Col md={12} className="text-center text-md-start">
                        <p className="copyright-text">
                            &copy; {new Date().getFullYear()} Kingdom Connection Christian Center. All Rights Reserved.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};